module.exports = __webpack_public_path__ + "static/media/check-circle.b9a93aae.svg";